export const headCells = [
  {
    id: 'tags',
    label: 'Tags',
  },
  {
    id: 'modified',
    label: 'Última modificação',
  },
  {
    id: 'count',
    label: 'Itens',
  },
  {
    id: 'action',
  },
]

export const tabLabels = ['Todas']
